<template>
  <section class="section" id="team">
    <div class="container">
      <div class="columns">
        <div class="column is-10-fullhd is-offset-1-fullhd products-title">
          <div class="content">
            <h4 class="is-uppercase has-text-centered has-text-primary mb-6">
              {{ texts.title }}
            </h4>
          </div>
        </div>
      </div>
      <div class="columns pictures is-multiline">
        <div
          v-for="teamMember in team"
          :key="teamMember.name"
          class="column is-6-tablet is-6-desktop is-5-widescreen is-hidden-mobile"
        >
          <div class="teamCard">
            <figure class="image">
              <img class="is-rounded" :src="teamMember.image" />
            </figure>
            <div class="teamName has-text-primary has-text-centered">
              {{ teamMember.name }}
            </div>
            <div
              class="teamPosition has-text-primary has-text-centered has-text-weight-normal"
            >
              {{ texts.teamMembers[teamMember.position] }}
            </div>
            <!-- <div class="teamIntroduction has-text-primary">
              {{ texts.teamMembers[teamMember.introduction] }}
            </div> -->
          </div>
        </div>
      </div>

      <carousel
        :per-page="1"
        :mouse-drag="true"
        :minSwipeDistance="1"
        :paginationPadding="5"
        :paginationSize="7"
        class="is-hidden-tablet"
      >
        <slide
          v-for="teamMember in team"
          :key="teamMember.name"
          class="teamCard"
        >
          <figure class="image">
            <img class="is-rounded" :src="teamMember.image" />
          </figure>
          <div class="teamName has-text-primary has-text-centered">
            {{ teamMember.name }}
          </div>
          <div
            class="teamPosition has-text-primary has-text-centered has-text-weight-normal"
          >
            {{ texts.teamMembers[teamMember.position] }}
          </div>
          <!-- <div class="teamIntroduction has-text-primary">
            {{ texts.teamMembers[teamMember.introduction] }}
          </div> -->
        </slide>
      </carousel>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  data() {
    return {
      team: [
        {
          name: "Kovács-Szécsi Henrieta",
          position: "p-henrietta",
          image: require("../assets/images/team/Kovacs-Szecsi_Henrieta - Founder.jpg"),
        },
        
        {
          name: "Kovács-Szécsi Attila",
          position: "p-kszattila",
          image: require("../assets/images/team/Kovacs-Szecsi_Attila_-General Director.jpg"),
        },
        {
          name: "Székely Tibor",
          position: "p-sztibor",
          image: require("../assets/images/team/Szekely Tibor - Welder and Assembler.jpg"),
        },
        {
          name: "Szentes László",
          position: "p-laszlo",
          image: require("../assets/images/team/Szentes Laszlo - Welder and Assembler.jpg"),
        },
        {
          name: "Szakács Botond",
          position: "p-botond",
          image: require("../assets/images/team/SzakacsBotond- Co-Founder.jpg"),
        },
      ],
    };
  },
  components: {
    Carousel,
    Slide,
  },
  computed: {
    texts() {
      return this.$t("team");
    },
  },
};
</script>

<style lang="scss" scoped>
#team {
  .columns.pictures {
    justify-content: center;
    padding: 0 10.33%
  }
  .teamCard {
    padding: 1rem 0;
    figure {
      display: flex;
      justify-content: center;
    }
    .teamName {
      font-weight: 700;
      margin: 1rem 0 0.5rem 0;
    }
  }
  .pictures img {
    border-color: #f4f4f2;
    border-style: solid;
    border-width: 16px;
    box-sizing: content-box;
    width: 65%;
  }

  @include mobile {
    .image {
      display: flex;
      img {
        max-width: 75%;
        margin: 0 auto;
      }
    }
    .pictures .image {
      display: block;
    }
  }
}
</style>
